import * as React from 'react';

function SvgTickCorrect(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={8} {...props}>
      <path d="M1.652 3.255a.8.8 0 00-1.122.002l-.298.294A.779.779 0 00.23 4.659l2.79 2.753a.793.793 0 00.56.229.812.812 0 00.564-.233l5.623-5.552A.779.779 0 009.768.744L9.47.45a.806.806 0 00-1.126.002L3.58 5.158 1.652 3.255z" />
    </svg>
  );
}

export default SvgTickCorrect;
